"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetCategoryToJSON = exports.AssetCategoryFromJSONTyped = exports.AssetCategoryFromJSON = exports.AssetCategory = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var AssetCategory;
(function (AssetCategory) {
    AssetCategory["AdminAssetManager"] = "AdminAssetManager";
})(AssetCategory = exports.AssetCategory || (exports.AssetCategory = {}));
function AssetCategoryFromJSON(json) {
    return AssetCategoryFromJSONTyped(json, false);
}
exports.AssetCategoryFromJSON = AssetCategoryFromJSON;
function AssetCategoryFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AssetCategoryFromJSONTyped = AssetCategoryFromJSONTyped;
function AssetCategoryToJSON(value) {
    return value;
}
exports.AssetCategoryToJSON = AssetCategoryToJSON;
